import { render, staticRenderFns } from "./ProductReviewStars.vue?vue&type=template&id=40eb9350&"
import script from "./ProductReviewStars.vue?vue&type=script&lang=js&"
export * from "./ProductReviewStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default})
